import React, { type ReactElement } from "react";

import { useTranslations } from "@rootreeweb/react-translations";

import type { FillOption } from "../types.js";
import Cell from "./Cell.js";

type Props = {
	fillOptions: FillOption[];
	hasAny: boolean;
};

/**
 *
 *
 * @param props The props for the component.
 * @returns The component.
 */
export default function Headings(props: Props): ReactElement {
	const { fillOptions, hasAny } = props;
	const { getTranslation } = useTranslations();
	return (
		<tr>
			<Cell isHeader={true} scope="col">
				{getTranslation("core-size")}
			</Cell>
			<Cell isHeader={true} scope="col">
				{getTranslation("dimensions")}
			</Cell>
			{fillOptions
				.filter((option) => {
					return option.hasAny && option.label;
				})
				.map((fillOption) => {
					return (
						<Cell isHeader={true} key={fillOption.label} scope="col">
							{fillOption.label}
						</Cell>
					);
				})}
			{!hasAny && (
				<Cell isHeader={true} scope="col">
					{getTranslation("recc-fill")}
				</Cell>
			)}
		</tr>
	);
}
